export const shouldExcludeByGeoLocation = (
  excludedCountries,
  accessCountry,
  isLoggedIn
) => {
  if (excludedCountries?.length === 0 || !isLoggedIn) return false

  return excludedCountries?.includes(accessCountry)
}

export const filterGeoBlockedItems = (items, accessCountry, isLoggedIn) => {
  if (items?.length === 0) return []
  return items?.filter(
    (item) =>
      !shouldExcludeByGeoLocation(
        item?.exclude_by_geo_location,
        accessCountry,
        isLoggedIn
      )
  )
}
